import React from 'react'
import classNames from 'classnames'
import type { TFundingBannerFormWrapperProps } from './types'
import './styles.scss'

export const FundingBannerFormWrapper = ({ children, className }: TFundingBannerFormWrapperProps) => {
  return <div className={classNames('fundingBannerFormWrapper', className)}>{children}</div>
}
